import {
	RESET_STATE,
	SET_CLAIM_CATEGORIES,
	SET_CLAIM_PRIORITIES,
	SET_CLAIM_SECTIONS,
	SET_CLAIMS_COUNT,
	SET_CLAIMS_LIST,
	SET_IS_CLAIM_CATEGORIES_LOADING,
	SET_IS_CLAIM_PRIORITIES_LOADING,
	SET_IS_CLAIM_SECTIONS_LOADING,
	SET_IS_CLAIMS_LIST_LOADING,
	SET_PAGINATION,
	SET_TABLE_SEARCH,
} from './actions';

export const initialState = {
	claimsList: [],
	isClaimsListLoading: false,
	pagination: null,
	tableSearch: '',
	count: {},
	claimCategories: [],
	isCategoriesLoading: false,
	claimPriorities: [],
	isPrioritiesLoading: false,
	claimSections: [],
	isSectionsLoading: false,
};

const claimsContainerReducer = (state = initialState, action) => {
	const { type, payload } = action;

	switch (type) {
		case RESET_STATE:
			return initialState;
		case SET_CLAIMS_LIST:
			return { ...state, claimsList: payload };
		case SET_IS_CLAIMS_LIST_LOADING:
			return { ...state, isClaimsListLoading: payload };
		case SET_PAGINATION:
			return { ...state, pagination: payload };
		case SET_TABLE_SEARCH:
			return { ...state, tableSearch: payload };
		case SET_CLAIMS_COUNT:
			return { ...state, count: payload };
		case SET_CLAIM_CATEGORIES:
			return {
				...state,
				claimCategories: payload,
			};
		case SET_IS_CLAIM_CATEGORIES_LOADING:
			return {
				...state,
				isCategoriesLoading: payload,
			};
		case SET_CLAIM_PRIORITIES:
			return {
				...state,
				claimPriorities: payload,
			};
		case SET_IS_CLAIM_PRIORITIES_LOADING:
			return {
				...state,
				isPrioritiesLoading: payload,
			};
		case SET_CLAIM_SECTIONS:
			return {
				...state,
				claimSections: payload,
			};
		case SET_IS_CLAIM_SECTIONS_LOADING:
			return {
				...state,
				isSectionsLoading: payload,
			};
		default:
			return state;
	}
};

export default claimsContainerReducer;
